export default __webpack_public_path__ + "static/media/wippy_download_page_google_text_zh.9e0f9aaa.svg";